import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg className={(styles["Icon-svg"] || "Icon-svg") + " " + (styles["fill"] || "fill")} viewBox="0 0 100 100" {...props}><rect x="16.67%" y="16.67%" width="66%" height="66%" rx="10%" /></svg>);